(function (w) {
  String.prototype.Trim = function () // 扩展string前后去空格方法
  {
    return this.replace(/(^\s*)|(\s*$)/g, "");
  };

  String.prototype.endWith = function (endStr) {
    var d = this.length - endStr.length;
    return d >= 0 && this.lastIndexOf(endStr) == d;
  };

  if (/msie|applewebkit.+safari/i.test(w.navigator.userAgent)) {
    // 扩展safari浏览器 sort方法
    var _sort = Array.prototype.sort;
    Array.prototype.sort = function (fn) {
      if (!!fn && typeof fn === "function") {
        if (this.length < 2) return this;
        var i = 0,
          j = i + 1,
          l = this.length,
          tmp,
          r = false,
          t = 0;
        for (; i < l; i++) {
          for (j = i + 1; j < l; j++) {
            t = fn.call(this, this[i], this[j]);
            r = (typeof t === "number" ? t : t ? 1 : 0) > 0;
            if (r) {
              tmp = this[i];
              this[i] = this[j];
              this[j] = tmp;
            }
          }
        }
        return this;
      } else {
        return _sort.call(this);
      }
    };
  }
  var lycamWeb = {};
  lycamWeb.getHost = function () {
    // 根据环境获取后台访问域名
    if (
      window.location.href.indexOf("localhost") > -1 ||
      window.location.href.indexOf("127.0.0.1") > -1 ||
      window.location.href.indexOf("192.168") > -1
    ) {
      // return 'http://api-dev.shouboke.tv'
      return "http://gkb.gaozhaotong.cn/";
    }
    if (window.location.href.indexOf("logicsight.cn") > -1) {
      //			return "wx18e63e75d50cb458"//考宝学涯
      return "http://api.sbk.logicsight.cn";
      //			return "wxb5a883c5bf26e000"
    }
    if (window.location.href.indexOf("shouboke.tv/gaokaobao") > -1) {
      return "http://gkb.gaozhaotong.cn/";
    }
    if (window.location.href.indexOf("shouboke.tv") > -1) {
      return "http://gkb.gaozhaotong.cn/";
    }
    return "http://gkb.gaozhaotong.cn/";
  };
  lycamWeb.getAppid = function () {
    // 获取公众号appid
    if (window.location.href.indexOf("shouboke.tv/gaokaobao") > -1) {
      //			return "wx18e63e75d50cb458"//考宝学涯
      // return "wxe826ac7e43a1f976";
      return "wxe826ac7e43a1f976"
    }
    if (window.location.href.indexOf("test.shouboke.tv") > -1) {
      //			return "wx18e63e75d50cb458"//考宝学涯
      // return "wxe826ac7e43a1f976";
      return "wxe826ac7e43a1f976"
    }

    if (window.location.href.indexOf("logicsight.cn") > -1) {
      //			return "wx18e63e75d50cb458"//考宝学涯
      // return "wx6754bc84cfeabb68";
      return "wxb5a883c5bf26e000"
    }

    return "wxb5a883c5bf26e000";
  };

  lycamWeb.getIosHref = function () {
    let curl = window.location.href;
    let urls = curl.indexOf("#") > -1 ? curl.split("#") : null;
    if (!urls || urls.length <= 0) {
      return lycamWeb.webHost(true);
    } else {
      return window.location.href.split("#")[0];
    }
  };

  lycamWeb.needConfig = function (toName) {
    let arr = ["videoDetail","pcVideo", "mPdf", "orgCenter", "activity", "advList","goodUAList"];
    let a = arr.filter(function (i) {
      return i == toName;
    });

    return !a || a.length <= 0;
  };

  lycamWeb.getssUrl = function () {
    window.entryUrl = location.href.split("#")[0];

    // var u = navigator.userAgent;
    console.log("isIOS?", lycamWeb.isIOS());
    // var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; // g
    return lycamWeb.isIOS() ? window.entryUrl : window.location.href;
    // return isAndroid ? location.href.split("#")[0] : window.entryUrl;
  };
  lycamWeb.wxConfigUrl = function () {
    var surl = lycamWeb.getssUrl();
    console.log(surl);
    return surl; //            lycamWeb.isIOS() ? lycamWeb.getIosHref() : window.location.href;
  };

  lycamWeb.webHost = function (share) {
    // let url = "http://www.shouboke.tv/gaokaobao/index.html";
    let url = "http://kbxy.lycam.cn/";
    // 获取主页
    if (
      process.env.EVN_CONFIG === "test"
    ) {
      url = "http://kbxy.lycam.cn/test/index.html/";
    }
    return url;
  };
  lycamWeb.setCookie = function (c_name, value, expiredays) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    document.cookie =
      c_name +
      "=" +
      escape(value) +
      (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
  };
  lycamWeb.getCookie = function (name) {
    var arr,
      reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

    if ((arr = document.cookie.match(reg))) {

      return arr[2];
    } else {
      return null;
    }
  };
  lycamWeb.delCookie = function (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = lycamWeb.getCookie(name);
    if (cval != null) {

      document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
    }
  };

  lycamWeb.clearCookie = function () {
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (var i = keys.length; i--;) {
        // console.log(keys[i]);
        if (
          keys[i] != "token" &&
          keys[i] != "_subwx" &&
          keys[i].indexOf("_welcome_") == -1
        ) {
          document.cookie = keys[i] + "=0;expires=" + new Date(0).toUTCString();
        }

        if (keys[i].indexOf("_welcome_") > -1) {
          try {
            var last = lycamWeb.getCookie(keys[i]);
            if (last) {
              var now = new Date().getTime();
              var xiangcha = now - last;
              if (xiangcha > 30000) {
                document.cookie =
                  keys[i] + "=0;expires=" + new Date(0).toUTCString();
              }
            }
          } catch (e) {}
        }
      }
    }
  };

  lycamWeb.clearWelcomeCookie = function () {
    var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
    if (keys) {
      for (var i = keys.length; i--;) {
        // console.log(keys[i]);
        if (keys[i].indexOf("_welcome_") > -1) {
          try {
            var last = lycamWeb.getCookie(keys[i]);
            if (last) {
              var now = new Date().getTime();
              var xiangcha = now - last;
              if (xiangcha > 30000) {
                document.cookie =
                  keys[i] + "=0;expires=" + new Date(0).toUTCString();
              }
            }
          } catch (e) {}
        }
      }
    }
  };

  lycamWeb.parseQueryString = function (url) {
    var reg_url = /^[^\?]+\?([\w\W]+)$/,
      reg_para = /([^&=]+)=([\w\W]*?)(&|$)/g,
      arr_url = reg_url.exec(url),
      ret = {};
    if (arr_url && arr_url[1]) {
      var str_para = arr_url[1],
        result;
      while ((result = reg_para.exec(str_para)) != null) {
        ret[result[1]] = result[2];
      }
    }
    return ret;
  };
  lycamWeb.isPoneAvailable = function (str) {
    var myreg = /^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/;
    if (!myreg.test(str)) {
      return false;
    } else {
      return true;
    }
  };
  lycamWeb.is_weixn_qq = function () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return "weixin";
    } else if (ua.match(/QQ/i) == "qq") {
      return "QQ";
    }
    return false;
  };
  lycamWeb.randomString = function (len) {
    var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
    var maxPos = chars.length;
    var pwd = "";
    for (var i = 0; i < len; i++) {
      pwd += chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
  };
  lycamWeb.timeFormat = function (t, format) {
    var _this = new Date(t);
    var o = {
      "M+": _this.getMonth() + 1, // month
      "d+": _this.getDate(), // day
      "h+": _this.getHours(), // hour
      "m+": _this.getMinutes(), // minute
      "s+": _this.getSeconds(), // second
      "q+": Math.floor((_this.getMonth() + 3) / 3), // quarter
      S: _this.getMilliseconds() // millisecond
    };

    if (/(y+)/.test(format)) {
      format = format.replace(
        RegExp.$1,
        (_this.getFullYear() + "").substr(4 - RegExp.$1.length)
      );
    }

    for (var k in o) {
      if (new RegExp("(" + k + ")").test(format)) {
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length == 1 ?
          o[k] :
          ("00" + o[k]).substr(("" + o[k]).length)
        );
      }
    }
    return format;
  };

  // * 获取时间格式为：1970-01-01 00:00
  // * @param  {参数} params
  // * 属性         类型      默认值        必填    说明
  // * date         Date    new Date()      否     Date对象
  // * ms            int         0          否     获取距当前ms毫秒时间
  // * dateFormat   String      /           否      日期分隔符
  // * timeFormat   string      :           否      时间分隔符

  lycamWeb.anyTime = (params) => {
    console.log(params);

    const ms = (!params.ms ? 0 : params.ms);
    const date = !params.data ? new Date(new Date().getTime() + ms) : new Date(params.date.getTime() + ms);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();
    const second = date.getSeconds();
    const dateFormat = (!params.dateFormat) ? "-" : params.dateFormat;
    const timeFormat = (!params.timeFormat) ? ":" : params.timeFormat;
    return [year, month, day].map(formatNumber).join(dateFormat) + ' ' + [hour, minute, second].map(formatNumber).join(timeFormat);
  };
  const formatNumber = n => {
    n = n.toString();
    return n[1] ? n : '0' + n;
  };
  lycamWeb.changeTime = function (time, b) {
    var data = new Date(time.replace(/-/g, "/"));
    var year = data.getFullYear();
    var month = data.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    var day = data.getDate();
    if (day < 10) {
      day = "0" + day;
    }
    var hour = data.getHours();
    if (hour < 10) {
      hour = "0" + hour;
    }
    var minute = data.getMinutes();
    if (minute < 10) {
      minute = "0" + minute;
    }
    if (b == 1) {
      // 显示到月日时分
      time = month + "月" + day + "日 " + hour + ":" + minute;
    }
    if (b == 2) {
      // 显示年月日时分
      time = year + "年" + month + "月" + day + "日" + hour + ":" + minute;
    }
    if (b == 3) {
      // 显示年月日
      time = year + "年" + month + "月" + day + "日";
    }
    return time;
  };
  lycamWeb.IsPC = function () {
    var userAgentInfo = window.navigator.userAgent;
    var Agents = [
      "Android",
      "iPhone",
      "SymbianOS",
      "Windows Phone",
      "iPad",
      "iPod"
    ];
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
      if (userAgentInfo.indexOf(Agents[v]) > 0) {
        flag = false;
        break;
      }
    }
    return flag;
  };
  lycamWeb.isIOS = function () {
    var isIphone =
      window.navigator.userAgent.toLowerCase().indexOf("iphone") > -1;
    var isIpad = window.navigator.userAgent.toLowerCase().indexOf("ipad") > -1;
    return isIphone || isIpad;
  };

  lycamWeb.isTest = function () {
    if (
      window.location.href.indexOf("localhost") > -1 ||
      window.location.href.indexOf("127.0.0.1") > -1 ||
      window.location.href.indexOf("192.168") > -1 ||
      window.location.href.indexOf("0.0.0.0") > -1
    ) {
      console.log("test");
      return true;
    }
    return false;
  };
  lycamWeb.toRedirect = function () {
    if (lycamWeb.getCookie("_redirecturl")) {
      window.location.href = decodeURIComponent(
        lycamWeb.getCookie("_redirecturl")
      );
      lycamWeb.delCookie("_redirecturl");
      window.location.reload();
    }
  };
  lycamWeb.date2tmps = function (date) {
    var startDate = date;
    startDate = startDate.replace(new RegExp("-", "gm"), "/");
    var startDateM = new Date(startDate).getTime();
    // console.log(startDateM);
    return startDateM;
  };

  lycamWeb.afterNow = function (date) {
    var startDate = date;
    startDate = startDate.replace(new RegExp("-", "gm"), "/");
    var startDateM = new Date(startDate).getTime();
    // console.log(startDateM > new Date().getTime());
    return startDateM > new Date().getTime();
  };

  lycamWeb.d1AfterD2 = function (d1, d2) {
    var startDate = d1;
    startDate = startDate.replace(new RegExp("-", "gm"), "/");
    d2 = new Date(d2.replace(new RegExp("-", "gm"), "/")).getTime();
    var startDateM = new Date(startDate).getTime();
    // console.log(startDateM > new Date().getTime());
    return startDateM > d2;
  };

  lycamWeb.notNeedlogin = function () {
    var curl = window.location.href;
    // console.log(curl.endWith("#/"));
    var a = curl.endWith("#/");
    if (a) {
      return true;
    }

    if (curl.endWith("#/video")) {
      return true;
    }

    // , "pcVideo" "/oauth" "#/video"
    var npages = [,
      "pcVideo",
      "/searchAll",
      "videoDetail",
      "/mPdf",
      "appAgreement"
    ];
    var notneed = false;
    for (var i = 0; i < npages.length; i++) {
      // console.log(curl + "--" + npages[i]);
      if (curl.indexOf(npages[i]) > -1) {
        notneed = true;
        // console.log(curl + "--" + npages[i]);
        break;
      }
    }
    // console.log(notneed);
    return notneed;
  };

  lycamWeb.saveFallBackHref = function () {
    lycamWeb.setCookie("_redirecturl", window.location.href, 1);
  };

  lycamWeb.ArrayFormUniq = function (arr) {
    let hash = [];
    for (let i = 0; i < arr.length; i++) {
      if (hash.indexOf(arr[i]) === -1) {
        hash.push(arr[i]);
      }
    }
    return hash;
  };

  lycamWeb.isToday = function (str) {
    var d = new Date(
      str.replace(/-/g, "/").replace(new RegExp("-", "gm"), "/")
    );
    var todaysDate = new Date();
    if (d.setHours(0, 0, 0, 0) == todaysDate.setHours(0, 0, 0, 0)) {
      return true;
    } else {
      return false;
    }
  };

  lycamWeb.isToyear = function (date) {
    return (
      new Date().getFullYear() ==
      new Date(date.replace(/-/g, "/")).getFullYear()
    );
  };
  lycamWeb.shotDate = function (date) {
    var data = new Date(date.replace(/-/g, "/"));
    var year = data.getFullYear();
    var month = data.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    var day = data.getDate();
    if (day < 10) {
      day = "0" + day;
    }
    if (lycamWeb.isToyear(date)) {
      return month + "月" + day + "日";
    } else {
      return year + "年" + month + "月" + day + "日 ";
    }
  };

  lycamWeb.getUrl = function (content) {
    var reg = /(https?|http|ftp|file):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/g;
    var urlarr = content.match(reg);
    try {
      for (var i = 0; i < urlarr.length; i++) {
        // console.log(urlarr[i]);
        if (lycamWeb.isPic(urlarr[i])) {
          content = content.replace(
            urlarr[i],
            "<br/><img src='" +
            urlarr[i] +
            "' style='max-width:100%;'></img><br/>"
          );
        } else {
          content = content.replace(
            urlarr[i],
            "<a href='" +
            urlarr[i] +
            "' style='color:red;font-size:12px'><U>《打开链接" +
            urlarr[i] +
            "》</U></a>"
          );
        }
      }
    } catch (e) {}
    // content = content.replace(
    //   reg,
    //   "<a href='$1$2' style='color:red;font-weight:900;font-size:12px'><U>《点击打开:$1$2》</U></a>"
    // );
    // console.log(urlarr);
    return content;
  };

  lycamWeb.isPic = function (url) {
    var url = url.Trim().toLowerCase();
    return (
      url.endWith(".jpg") ||
      url.endWith(".gif") ||
      url.endWith(".png") ||
      url.endWith(".jpeg")
    );
  };

  lycamWeb.filterChat = function (content) {
    try {
      content = content.replace(/[\n\r]/g, "");
      // console.log(content);
    } catch (e) {
      // return content;
    }

    return content;
  };
  // 判断是否是微信浏览器
   lycamWeb.isWeixin=function() {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return true;
    } else {
      return false;
    }
  };

  w.lycamWeb = lycamWeb;
})(window);



// WEBPACK FOOTER //
// ./src/assets/js/common.js